<template>
  <v-row>
    <v-col cols="12" md="8" offset-md="2">
      <v-card class="wrapper">
        <v-card-title primary-title class="primary">
          <div>
            <h3 class="headline mb-0 white--text">
              Bienvenido
            </h3>
          </div>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row v-for="(noticia, index) in noticias" :key="index">
            <v-col class="d-sm-inline-flex justify-start">
              <v-img
                max-width="200"
                max-height="150"
                class="mr-4"
                :src="noticia.foto"
              />
              <div class="text-justify">
                <p class="headline mb-1">
                  {{ noticia.titulo }}
                </p>
                <p>
                  {{ noticia.descripcion }}
                </p>
                <a :href="noticia.link" target="_blank" rel="noopener noreferrer" class="mt-2">ver más...</a>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import graphql from '../utils/graphql';

export default {
  data() {
    return {
      noticias: []
    }
  },

  computed: {
    localSeleccionado() {
      return this.$store.state.local;
    }
  },

  watch: {
    localSeleccionado() {
      this.noticias = [];
      this.loadNoticias();
    }
  },

  created() {
    this.loadNoticias();
  },

  methods: {
    async loadNoticias() {
      try {
        const {fspCodigo, sedCodigo, lapCodigo} = this.localSeleccionado;
        const query = {
          query: `
              query ($fspCodigo: Int!, $sedCodigo: Int!, $lapCodigo: Int!) {
                noticias: noticias(fspCodigo: $fspCodigo, sedCodigo: $sedCodigo, lapCodigo: $lapCodigo) {
                  titulo
                  descripcion
                  foto
                  link
                }
              }
            `,
          variables : {
            fspCodigo,
            sedCodigo,
            lapCodigo,
          }
        };
        const { noticias } = await graphql.request(query);
        this.noticias = noticias;
      } catch(err) {
        this.$store.commit('error-notification', err.message);
      }
    },
  }
};
</script>
